<template>
  <lazy-component @show="handler">
    <div class="box">
      <div class="thumbnail">
        <div v-if="error" class="error">Slide missing</div>

        <div v-else>
          <div class="loading" v-if="!loaded">Loading...</div>

          <a :href="target" target="_blank" class="thumb" v-if="loaded">
            <img :src="image_url" />
          </a>
        </div>
      </div>
      <div class="thumbnail-caption">
        <a :href="target" target="_blank">{{ caption }}</a>
      </div>
    </div>
  </lazy-component>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["src", "placeholder", "target", "caption"],
  data() {
    return {
      image_url: this.placeholder || this.src || "",
      loaded: false,
      error: false
    };
  },
  mounted() {
    // this.handler()
    // if (this.src){
    //   this.$nextTick(()=>{
    //     this.preload(this.src)
    //   })
    // }
  },
  watch: {
    src: val => {
      this.loaded = false;
      this.preload(val);
    }
  },
  methods: {
    handler() {
      this.preload(this.src);
    },
    preload(img) {
      this.checkFileURL(img).then(response => {
        if (response.success && response.status === 200) {
          this.fetchThumbnail(img).then(thumbnail => {
            // console.log(thumbnail)
            if (thumbnail.success) {
              const img = new Image();
              const vm = this;
              img.onload = () => {
                vm.image_url = thumbnail.url;
                vm.loaded = true;
              };
              img.onerror = () => {
                vm.loaded = false;
                vm.error = true;
              };
              // console.log("updating url");
              img.src = thumbnail.url;
            } else {
              this.loaded = false;
              this.error = true;
            }
          });
        } else {
          this.loaded = false;
          this.error = true;
        }
      });
    },
    ...mapActions(["fetchThumbnail", "checkFileURL"])
  }
};
</script>
<style>
.loading,
.error,
.thumb {
  width: 100%;
  min-height: 100px;
  text-align: center;
}
.error {
  color: grey;
}
.thumbnail {
  width: 100%;
  /* border: 1px solid #dedede; */
}
.thumbnail img {
  width: 100%;
}
.thumbnail-caption {
  text-align: center;
  text-transform: full-width;
}
</style>
